import React, { useState, useEffect } from "react";
import { Link, LazyLoadImages } from "@quintype/components";
import { ResponsiveBannerImage } from "../../utils/responsive-image";
import { getLatestMagazine } from "../utils/api";

function isValidMagazine(magazine) {
  return Boolean(magazine?.slug && magazine?.metadata?.["cover-image"]?.["cover-image-s3-key"]);
}

function getMagazineFromApiData(payload = {}) {
  const topLevelStoryCollection = payload?.["story-collections"]?.[0] || payload?.storyCollections?.[0];
  if (isValidMagazine(topLevelStoryCollection)) {
    return topLevelStoryCollection;
  }

  const directItem = payload?.items?.[0];
  if (isValidMagazine(directItem)) {
    return directItem;
  }

  const firstCollection = payload?.["story-collections"]?.[0] || payload?.storyCollections?.[0];
  const nestedItem = firstCollection?.items?.[0];
  if (isValidMagazine(nestedItem)) {
    return nestedItem;
  }

  return null;
}

const MagazineSideCol = () => {
  const [magazine, setMagazine] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function fetchMagazine() {
      setIsLoading(true);
      try {
        const response = await getLatestMagazine();
        if (!isMounted) {
          return;
        }
        const resolvedMagazine = getMagazineFromApiData(response);
        if (!resolvedMagazine) {
          console.warn("MagazineSideCol: Unable to resolve valid magazine from API response");
        }
        setMagazine(resolvedMagazine);
      } catch (error) {
        if (isMounted) {
          setMagazine(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    fetchMagazine();
    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return (
      <div className="mt-5 px-5 py-4">
        <div className="h-[350px] w-full animate-pulse bg-gray-300"></div>
      </div>
    );
  }

  if (!magazine) {
    return null;
  }

  return (
    <div className="mt-5 flex  justify-center bg-[#f1f0ef] px-5  py-4 dark:bg-zinc-800">
      <div className="flex w-full flex-col">
        <div className="ml-[26px]">
          <h2 className="text-2xl font-bold text-[#ca4242] ">Magazine</h2>
          <hr className="mt-1 h-[4px] w-[20%] border-none  bg-primary" />
        </div>
        <figure className="mt-3 flex justify-center">
          <Link href={`/issue/${magazine.slug}`}>
            <div className="w-[208px]">
              <LazyLoadImages>
                {/* <ResponsiveImage
                  slug={magazine.metadata["cover-image"]["cover-image-s3-key"]}
                  aspect-ratio={[1, 1]}
                  defaultWidth={268}
                  imgParams={{ auto: ["format", "compress"], q: 75, fm: "webp" }}
                  alt="image"
                /> */}

                <ResponsiveBannerImage
                  slug={magazine.metadata["cover-image"]["cover-image-s3-key"]}
                  alt="image"
                  quality="25"
                  width="500"
                />
              </LazyLoadImages>
            </div>
          </Link>
        </figure>
      </div>
    </div>
  );
};

export default MagazineSideCol;
